import React, { useState, useEffect } from "react";
import versionApiInstance from "../../api/VersionApi";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Menu,
  MenuItem,
  Avatar,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
} from "@mui/material";
import Logo from "../../assets/shrood_logo.png"; // Your logo file
import { useCookies } from "react-cookie";
import InfoIcon from "@mui/icons-material/Info"; // Import the info icon

const Header = ({ currentUser }) => {
  const [, , removeCookie] = useCookies(["auth_token", "user_info"]); // Access cookie management functions
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [open, setOpen] = useState(false);
  const [versionInfo, setVersionInfo] = useState({
    version: "",
    release_date: "",
  });

  useEffect(() => {
    versionApiInstance.fetch("/version").then((res) => {
      setVersionInfo(res.data);
    });
  }, []);

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/logout`,
        {
          method: "POST",
          credentials: "include", // Include cookies
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.ok) {
        const { microsoft_logout_url } = await response.json();
        // Clear cookies
        removeCookie("auth_token", { path: "/" });
        removeCookie("refresh_token", { path: "/" });
        removeCookie("user_info", { path: "/" });

        // Redirect to Microsoft logout page
        window.location.href = microsoft_logout_url;
      } else {
        console.error("Failed to log out");
      }
    } catch (err) {
      console.error("Error during logout:", err);
    }
  };

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <AppBar position="sticky" sx={{ zIndex: 1201, top: 0 }}>
      <Toolbar sx={{ position: "relative" }}>
        {/* Logo */}
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <img
            src={Logo}
            alt="Logo"
            style={{
              height: 80,
              marginRight: 16,
              filter: "brightness(0) invert(1)",
            }}
          />
        </Box>

        {/* Centered Title */}
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{ textAlign: "center", fontStyle: "bold" }}
          >
            Frame Product Store Matrix
          </Typography>
        </Box>

        {/* User Information */}
        {currentUser && (
          <Box display="flex" alignItems="center">
            <Tooltip
              title={`${currentUser?.name} - ${currentUser?.email}`}
              arrow
            >
              <Avatar onClick={handleMenuOpen} sx={{ cursor: "pointer" }}>
                {currentUser?.name?.[0] || "U"}
              </Avatar>
            </Tooltip>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem>{currentUser?.name}</MenuItem>
              <MenuItem>{currentUser?.email}</MenuItem>
              <MenuItem
                onClick={() => {
                  setOpen(true);
                  handleMenuClose();
                }}
              >
                About
              </MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <InfoIcon sx={{ fontSize: 50, color: "#1976D2", mb: 1 }} />
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            Version: v{versionInfo.version}
          </Typography>
          <Typography variant="h6">
            Release Date:{versionInfo.release_date}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={() => setOpen(false)} variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
};

export default Header;
